<template>
  <div id="compreSportsMeet_scheduleDetail" v-show="currThemeObj">
    <div class="abs_top">
      <scheduleDetail_inforPanel
        :currThemeObj="currThemeObj"
        :matchInfor="matchPanel_matchInfor"
        :paramsItem="matchPanel_paramsItem"
        :matchEventList="matchPanel_matchEventList"
        @eventItemShowTipClickEvent="eventItemShowTipHandler"
      ></scheduleDetail_inforPanel>
      <div class="selectTab_area">
        <selectTab
          :currThemeObj="currThemeObj"
          :tabArr="tabArr"
          :pageJumpParams="selectTab_pageJumpParams"
          @clickTabEvent="onChangeTab"
        ></selectTab>
      </div>
    </div>
    <div>
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :matchInfor="matchPanel_matchInfor"
        :sportsTypeArr="sportsTypeArr"
        :isRefresh="isRefresh"
        :refreshTime="refreshTime"
        :bigSportsList="bigSportsList"
        :curTimeZoneItem="curTimeZoneItem"
      ></router-view>
    </div>
  </div>
</template>

<script>
import scheduleDetail_inforPanel from './scheduleDetail_inforPanel.vue'
import selectTab from '@components/platfromBase/compreSportsMeet/selectTab.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

import { https_delegationDetailInfor } from '@api/platfrom_compreSportsMeet_api'
export default {
  name: 'compreSportsMeet_scheduleDetail',
  components: { scheduleDetail_inforPanel, selectTab },
  mixins: [cup_base_data_mixin],
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    bigSportsList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      isRefresh: false, //是否需要实时更新
      refreshTime: 15 * 1000,
      setIntervalId: null,
      matchPanel_paramsItem: {
        name: '',
        id: '',
        logo: '',
      },
      matchPanel_matchInfor: {
        gold: '',
        silver: '',
        bronze: '',
        medal: '',
        acnt: '',
        dcnt: '',
      },
      currMatchStatus: null, // Playing || Suspended
      tabArr: [
        {
          name: '赛程',
          id: 'schedule',
          pathName: 'CSMeetDelegationDetailSchedule',
          act: true,
        },
        {
          name: '参赛名单',
          id: 'player',
          pathName: 'CSMeetDelegationDetailPlayer',
          act: false,
        },
        {
          name: '获奖明细',
          id: 'medalList',
          pathName: 'CSMeetDelegationDetailMedalList',
          act: false,
        },
      ],
      selectTab_pageJumpParams: [],
      matchPanel_matchEventList: null,
    }
  },
  watch: {
    isRefresh(newVal, oldVal) {
      console.debug(`lineup isRefresh: ${newVal}, ${oldVal}`)
      if (newVal && !oldVal) {
        this.refreshCallbackHandle()
      } else if (!newVal && oldVal) {
        this.cancelRefreshCallBackHandle()
      }
    },
  },
  created() {
    this.tabArr = this.tabArr.map((tabItem) => {
      tabItem.pathName = `${tabItem.pathName}_${this.currCid}`
      return tabItem
    })
    console.debug('route:', this.$route)
    this.query = this.$route.query
    const params = this.$route.params
    this.selectTab_pageJumpParams = [this.query, params]
    this.matchPanel_paramsItem = {
      name: params.organisationName,
      id: params.organisationCode,
      logo: params.organisationLogo,
    }
    if (this.currGroup) {
      this.init()
    }
  },
  methods: {
    async init() {
      // this.origin_matchList = matchList_mock.data
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getScheduleDetail()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    cancelRefreshCallBackHandle() {
      clearInterval(this.setIntervalId)
      this.setIntervalId = null
    },
    refreshCallbackHandle() {
      this.query = this.$route.query
      this.setIntervalId = setInterval(() => {
        this.getScheduleDetail()
      }, this.refreshTime - 0)
    },
    onChangeTab(item) {
      this.tabArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
        } else {
          tabItem.act = false
        }
      })
    },
    eventItemShowTipHandler(data) {
      let matchEventList = this.matchEventList
      this.matchEventList = matchEventList.map((item) => {
        if (data.eventId == item.eventId) {
          item.isShowTip = !data.isShowTip
        }
        return item
      })
      this.updateMatchEventList()
      // console.debug(matchEventList)
      // this.matchEventList = matchEventList
    },
    updateMatchEventList() {
      let matchEventList = []
      if (
        !this.currMatchStatus ||
        this.currMatchStatus === 'Cancelled' ||
        this.currMatchStatus === 'Fixture' ||
        this.currMatchStatus === 'Postponed'
      ) {
        // 取消，排赛，推迟 不展示时间条，所以返回[]
        return matchEventList
      }

      // matchEventList = [
      //   {
      //     eventId: 1,
      //     homeAway: 'HOME',
      //     eventType: 'goalEvent',
      //     name: '球员c',
      //     timeText: '14′',
      //     eventTime: 14,
      //     totalTime: 90,
      //     timePer: (14 / 90).toFixed(4) * 100,
      //   },
      //   {
      //     eventId: 2,
      //     homeAway: 'AWAY',
      //     eventType: 'redCardEvent',
      //     name: '球员d',
      //     timeText: '25′',
      //     eventTime: 25,
      //     totalTime: 90,
      //     timePer: (25 / 90).toFixed(4) * 100,
      //   },
      // ]
      matchEventList = this.matchEventList
      console.debug('change list')
      if (
        this.currMatchStatus === 'Played' &&
        matchEventList[matchEventList.length - 1].eventType !== 'endEvent'
      ) {
        // 比赛结束且没有添加过结束事件的增加该事件
        matchEventList.push({
          eventId: matchEventList[matchEventList.length - 1].eventId + 1,
          eventType: 'endEvent',
          isShowTip: false,
          name: '',
          timeText: 'end',
          eventTime: this.totalTime,
          totalTime: this.totalTime,
          timePer: 100,
        })
      }
      this.matchPanel_matchEventList = matchEventList
    },
    async getScheduleDetail() {
      let params = {
        sid: this.currSid,
        delegationId: this.query.delegationId,
      }
      await https_delegationDetailInfor(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            const matchInfo = res.data
            this.matchPanel_matchInfor = matchInfo
            this.matchPanel_paramsItem = {
              name: matchInfo.organisationName,
              id: matchInfo.organisationCode,
              logo: matchInfo.organisationLogo,
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = {
                gold: '',
                silver: '',
                bronze: '',
                medal: '',
                acnt: '',
                dcnt: '',
              }
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_scheduleDetail {
  padding-top: 12.36vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 12.36vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_scheduleDetail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
    .selectTab_area {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      padding: 0 9.722vw;
      width: 100%;
      height: 2.778vw;
    }
  }
}
</style>
